export const en = {
    stars: {
        one: 'stars',
        some: 'stars',
        many: 'stars',
    },
    without_stars: 'without stars',
};
